import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import { isMobile, isSafari } from 'react-device-detect';

import Player from '@vimeo/player';
import { parseVimeoUrl } from '../utils/vimeo';

export default class VimeoBackgroundCover extends React.Component {

  static propTypes = {
    url: PropTypes.string.isRequired,
    onUpdate: PropTypes.func,
    onLoaded: PropTypes.func,
    onEnded: PropTypes.func,
    onError: PropTypes.func,
    background: PropTypes.bool,
    autoplay: PropTypes.bool,
    muted: PropTypes.bool,
    color: PropTypes.string,
    playbackRate: PropTypes.number,
    currentTime: PropTypes.number,
  }

  static defaultProps = {
    background: true,
    autoplay: true,
    muted: true,
    color: 'ec4e47',
    playbackRate: 1,
    currentTime: 0,
  }

  state = {
    width: '100%',
  }

  onResize = throttle((mobileSafariFix = false) => {
    const windowAspect = (window.innerHeight + (mobileSafariFix ? 74 : 0)) / window.innerWidth;
    if (this.aspectEl) {
      const videoAspect = this.aspectEl.offsetHeight / this.aspectEl.offsetWidth;
      // console.log(mobileSafariFix, windowAspect, { height: window.innerHeight, width: window.innerWidth }, videoAspect, { height: this.aspectEl.offsetHeight, width: this.aspectEl.offsetWidth });
      if (windowAspect > videoAspect) {
        this.setState({ width: (windowAspect / videoAspect) * 100 + '%' });
      } else {
        this.setState({ width: '100%' });
      }
    }
  }, 200);

  onUpdate = (event) => {
    this.props.onUpdate(event);
  }
  onLoaded = (event) => {
    this.props.onLoaded(event, this.player);
  }
  onEnded = (event) => {
    this.props.onEnded(event);
  }
  onError = (event) => {
    this.props.onError(event);
  }

  _initPlayer = () => {
    if (this.player) {
      this.player.unload();
    }
    if (this.video && this.video instanceof HTMLElement) {
      // Full URL, not the bare id: unlisted videos need their privacy hash.
      const { id, url } = parseVimeoUrl(this.props.url);
      if (!id) return;
      const { background, autoplay, muted, color, playbackRate, currentTime } = this.props;
      this.player = new Player(this.video, {
        url,
        background,
        autoplay,
        autopause: 0,
        muted,
        loop: 1,
        color,
        playsinline: 1,
      });

      // this.player.ready().then(() => {
      //   const iframe = this.player.element;
      //   if (iframe) {
      //     iframe.setAttribute('allow', 'autoplay');
      //   }
      // });

      if (this.props.onUpdate) {
        this.player.on('timeupdate', this.onUpdate);
      }
      if (this.props.onPlay) {
        this.player.on('play', (event) => {
          if (currentTime > 0) {
            this.player.setCurrentTime(currentTime);
          }
          this.props.onPlay(event);
        });
      }
      if (this.props.onLoaded) {
        this.player.on('loaded', this.onLoaded);
      }
      if (this.props.onEnded) {
        this.player.on('ended', this.onEnded);
      }
      if (this.props.onError) {
        this.player.on('error', this.onError);
      }

      if (autoplay) {
        this.player.play();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      if (this.player) {
        const { url } = parseVimeoUrl(this.props.url);
        this.player.loadVideo(url).then(function(id) {
        }).catch(this.onError);
      }
    }
  }

  componentDidMount() {
    this._initPlayer();

    if (window) {
      if (!isMobile) {
        window.addEventListener('resize', this.onResize);
      } else {
        window.addEventListener('orientationchange', this.onResize);
      }
      setTimeout(() => {
        this.onResize(isMobile && isSafari);
      }, 200);
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.off('timeupdate', this.onUpdate);
      this.player.off('loaded', this.onLoaded);
      this.player.off('ended', this.onEnded);
      this.player.unload();
    }

    if (window) {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.onResize);
    }
  }

  render() {
    const { width } = this.state;
    return (
      <div className={`b-video-container-width ${this.props.className}`} style={{ width }}>
        <div className="b-video-container-aspect" ref={ref => this.aspectEl = ref}>
          <div className="b-video-container-make-height" ref={ref => this.video = ref} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VimeoBackgroundCover.js